export const applyMedicationActorPolicy = (payload, doctorMode = false) => {
  if (!payload) return payload;

  const next = { ...payload };
  if (doctorMode) {
    // Reminder settings are patient-owned. Omitting them preserves the
    // existing value while allowing the doctor to update treatment fields.
    delete next.alarmOn;
    delete next.reminders;
  }

  return next;
};
